import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useAuth } from "../auth/AuthProvider";
import { useMutation } from "../hooks/useResource";
import { ErrorBanner, LoadingState } from "../components/common";

export function LoginPage() {
  const { user, signIn } = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const login = useMutation(async () => {
    await signIn(email.trim(), password);
  });

  if (user === undefined) {
    return (
      <Box sx={{ p: 6 }}>
        <LoadingState label="Checking session…" />
      </Box>
    );
  }
  if (user) {
    const from = (location.state as { from?: string } | null)?.from;
    return <Navigate to={from && from !== "/login" ? from : "/"} replace />;
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        p: 3,
        bgcolor: "background.default",
      }}
    >
      <Paper sx={{ p: 4, width: 380, maxWidth: "100%" }} elevation={2}>
        <Typography variant="h5">FieldClients</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 3 }}>
          Operations console
        </Typography>

        <ErrorBanner error={login.error} />

        <Box
          component="form"
          onSubmit={(e) => {
            e.preventDefault();
            void login.run(undefined);
          }}
        >
          <Stack spacing={2}>
            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              autoFocus
              fullWidth
            />
            <TextField
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              fullWidth
            />
            <Button
              type="submit"
              variant="contained"
              size="medium"
              disabled={login.pending || email === "" || password === ""}
            >
              {login.pending ? "Signing in…" : "Sign in"}
            </Button>
          </Stack>
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 3 }}>
          Accounts are created by an owner, or from the CLI with
          {" "}
          <code>seed-admin</code>. Repeated failures are rate limited.
        </Typography>
      </Paper>
    </Box>
  );
}
